export const isFileExtensionValid = (supportedFileTypesSetting, fileName) => {
    var _a;
    const fileExtension = (_a = fileName.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase().trim();
    return Object.values(supportedFileTypesSetting)
        .flat()
        .some((supportedFileType) => supportedFileType.fileExtension.toLowerCase() === fileExtension);
};
